import React, { useState, useRef } from "react";
import Navbar from '../../components/Navbar'
import Footer from "../../components/Footer";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import FoodMainImage from '../../assets/food-home-image.png'
import FutureResturentManagementImage from '../../assets/future-resturent-management-image.png'
import PowerfullFeatureIcon1 from '../../assets/powerfull-feature-food-icon-1.png'
import PowerfullFeatureIcon2 from '../../assets/powerfull-feature-food-icon-2.png'
import PowerfullFeatureIcon3 from '../../assets/powerfull-feature-food-icon-3.png'
import PowerfullFeatureIcon4 from '../../assets/powerfull-feature-food-icon-4.png'
import PowerfullFeatureIcon5 from '../../assets/powerfull-feature-food-icon-5.png'
import PowerfullFeatureIcon6 from '../../assets/powerfull-feature-food-icon-6.png'
import PowerfullFeatureImage1 from '../../assets/powerfull-feature-food-image-1.png'
import PowerfullFeatureImage2 from '../../assets/powerfull-feature-food-image-2.png'
import PowerfullFeatureImage3 from '../../assets/powerfull-feature-food-image-3.png'
import PowerfullFeatureImage4 from '../../assets/powerfull-feature-food-image-4.png'
import PowerfullFeatureImage5 from '../../assets/powerfull-feature-food-image-5.png'
import PowerfullFeatureImage6 from '../../assets/powerfull-feature-food-image-6.png'
import PowerfullFeatureImage7 from '../../assets/powerfull-feature-food-image-7.png'
import PowerfullFeatureImage8 from '../../assets/powerfull-feature-food-image-8.png'
import NeverMissImage from '../../assets/never-miss-main-image.png'
import SliderImage1 from '../../assets/why-choose-platform-slick-image-1.jpg'
import SliderImage2 from '../../assets/slick-image-2.jpg'
import SliderImage3 from '../../assets/slick-image-3.jpg'
import SlickIconImage1 from '../../assets/slick-image-icon-1.png'
import SlickIconImage2 from '../../assets/slick-image-icon-2.png'
import SlickIconImage3 from '../../assets/slick-image-icon-3.png'
import SlickIconImage4 from '../../assets/slick-image-2-icon-1.png'
import SlickIconImage5 from '../../assets/slick-image-2-icon-2.png'
import SlickIconImage6 from '../../assets/slick-image-2-icon-3.png'
import SlickIconImage7 from '../../assets/slick-image-3-icon-1.png'
import SlickIconImage8 from '../../assets/slick-image-2-icon-2.png'
import SlickIconImage9 from '../../assets/slick-image-3-icon-3.png'
import FoodVariousImage1 from '../../assets/food-dine-in-image.jpg'
import FoodVariousImage2 from '../../assets/food-qrs-image.jpg'
import FoodVariousImage3 from '../../assets/food-backery-image.jpg'
import FoodVariousImage4 from '../../assets/food-bars-image.jpg'
import FoodVariousImage5 from '../../assets/food-hotels-image-2.jpg'
import PointTick from '../../assets/point-tick.png'
import WhiteColorTick from '../../assets/white-color-tick.png'
import WhatsappSmallIcon from '../../assets/whatsapp-small-icon.png'
import sendMessageImage from '../../assets/send-message-image.png'
import MessageIcon from '../../assets/message-icon-home-1.png'
import LocationIcon from '../../assets/location-icon-contactus.png'
import './Food.css'
import { TypeAnimation } from 'react-type-animation';
const hotelData = [
    {
        name: "Dine-In",
        title: "Dine-In",
        points: [
            "Manage tables digitally",
            "Split bills and merge orders easily",
            "Real-time kitchen order tracking",
        ],
        image: FoodVariousImage1,
    },
    {
        name: "QSR",
        title: "QSR",
        points: [
            "Lightning-fast checkout",
            "Combo deal & upselling support",
            "Kiosk/self-service friendly",
        ],
        image: FoodVariousImage2,
    },
    {
        name: "Bakery",
        title: "Bakery",
        points: [
            "Custom order",
            "Pre-orders and advance booking",
            "Fresh inventory & seasonal item tracking",
        ],
        image: FoodVariousImage3,
    },
    {
        name: "Pubs/Bars",
        title: "Pubs/Bars",
        points: [
            "Manage bar tabs with ease",
            "Track liquor pour costs",
            "Automated happy-hour pricing",
        ],
        image: FoodVariousImage4,
    },
    {
        name: " Stays",
        title: " Stays",
        points: [
            "Integrated In-room Ordering",
            "Centralized kitchen order management",
            "In-room QR Menu",
        ],
        image: FoodVariousImage5,
    }
];


function Food() {
    const [selected, setSelected] = useState(hotelData[0]);
    const [activeView, setActiveView] = useState('contact');
    const sectionRef = useRef(null);
    const sectionRefPlan = useRef(null);

    const scrollToSection = () => {
        sectionRef.current?.scrollIntoView({ behavior: "smooth" });
    };
    const scrollToSectionPlan = () => {
        sectionRefPlan.current?.scrollIntoView({ behavior: "smooth" });
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
    };

    const [formData, setFormData] = useState({
        name: "",
        product: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleWhatsAppSubmit = (e) => {
        e.preventDefault();

        const phoneNumber = "+917386616587";
        const { name, product } = formData;

        const whatsappMessage = `Hey, I am ${name}.\n\nI am interested in ${product} POS.\n\nLooking forward to a demo!`;

        const encodedMessage = encodeURIComponent(whatsappMessage);

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;

        window.open(whatsappUrl, "_blank");
        setFormData({
            name: "",
            product: "",
        });
    };


    return (
        <>
            <Navbar />
            <div className="food-home-main-container">
                <div className="food-home-content-container">
                    <div className="food-content">
                        {/* <h1 className="food-main-heading">Revolutionize Your Restaurant Operations</h1> */}
                        <TypeAnimation
                    sequence={[
                        // Same substring at the start will only be typed out once, initially
                        'Revolutionize Your Restaurant Operations',
                        1000, // wait 1s before replacing "Mice" with "Hamsters"
                        'Revolutionize Your Restaurant Operations For Restaurants',
                        2000,
                        'Revolutionize Your Restaurant Operations For Bakeries',
                        2000,
                        'Revolutionize Your Restaurant Operations For Food Courts',
                        2000,
                        'Revolutionize Your Restaurant Operations For Pubs',
                        2000,
                        'Revolutionize Your Restaurant Operations For Bars',
                        2000,
                        'Revolutionize Your Restaurant Operations For Theatres & Franchises',
                        2000
                    ]}
                    wrapper="span"
                    speed={50}
                    // style={{ fontSize: '42px', display: 'inline-block',color:"white",fontWeight:"bold",marginTop:"12px" }}
                    className="food-main-heading"
                    repeat={Infinity}
                />
                        <p className="food-main-description">Seamless POS, Contactless Dining, and Real-Time Management</p>
                        <div className="food-main-buttons-container">
                            <button className="food-home-buttons" onClick={scrollToSection}>Request a Demo</button>
                            <button className="food-home-buttons view-food-button" onClick={scrollToSectionPlan}>View Pricing</button>
                        </div>
                    </div>
                    <img src={FoodMainImage} alt="food-main-image" className="food-main-image" />
                </div>
            </div>

            <div className="futureof-resturent-main-container">
                <div className="futureof-resturent-content-container">
                    <h1 className="futureof-resturent-heading">Crafted for the <span className="food-span">Future</span> of Restaurant Management</h1>
                    <p className="futureof-resturent-description">FleetOrder emerges from SassyMonks Private Limited with a mission to revolutionize the F&B industry. We understand the real-world challenges restaurants face and have crafted solutions that bridge the gap between traditional operations and modern digital excellence.</p>
                    <img src={FutureResturentManagementImage} alt="future-restureent-management-image" className="future-resturent-management-image" />
                    <button className="learn-more-button" onClick={scrollToSection}>Learn More About Us</button>
                </div>
            </div>

            <div className="powerfull-feature-food-main-container">
                <div className="powerfull-feature-food-content-container">
                    <h1 className="powerfull-feature-main-heading">Powerful Features for <span className="food-span">Modern Restaurants</span></h1>
                    <p className="powerfull-feature-main-description">FleetOrder's comprehensive suite of modules designed to handle all your restaurant needs with precision, speed, and reliability</p>
                </div>
                <div className="powerfull-features-cards-container">

                    <div className="powerfull-feature-card">
                        <div className="powerfull-feature-card-content-container">
                            <img src={PowerfullFeatureIcon1} alt="powerfull-feature-icon" className="powerfull-feature-icon" />
                            <h1 className="powerfull-feature-card-title">POS System & Billing</h1>
                            <p className="powerfull-feature-card-description">Experience lightning-fast billing, seamless table management, and integrated payment solutions. Our intuitive POS is designed
                                for speed and reliability, ensuring a smooth checkout process for your customers every single time.
                            </p>
                            <img src={PowerfullFeatureImage1} className="powerfull-feature-image" alt="powerfull-feature-image" />
                        </div>
                    </div>

                    <div className="powerfull-feature-card">
                        <div className="powerfull-feature-card-content-container">
                            <img src={PowerfullFeatureIcon2} alt="powerfull-feature-icon" className="powerfull-feature-icon" />
                            <h1 className="powerfull-feature-card-title">Online Ordering Platform</h1>
                            <p className="powerfull-feature-card-description">Transform your restaurant with our powerful online ordering system. Enable customers to browse, customize, and order
                                directly from their devices with real-time menu updates and instant notifications.
                            </p>
                            <img src={PowerfullFeatureImage2} className="powerfull-feature-image second-image" alt="powerfull-feature-image" />
                        </div>
                    </div>

                    <div className="powerfull-feature-card">
                        <div className="powerfull-feature-card-content-container">
                            <img src={PowerfullFeatureIcon3} alt="powerfull-feature-icon" className="powerfull-feature-icon" />
                            <h1 className="powerfull-feature-card-title">Kitchen Display System</h1>
                            <p className="powerfull-feature-card-description">Streamline your kitchen operations with our advanced KDS. Real-time order tracking, preparation timers, and seamless
                                communication between front-of-house and kitchen staff for optimal efficiency.
                            </p>
                            <img src={PowerfullFeatureImage3} className="powerfull-feature-image" alt="powerfull-feature-image" />
                        </div>
                    </div>

                    <div className="powerfull-feature-card">
                        <div className="powerfull-feature-card-content-container">
                            <img src={PowerfullFeatureIcon4} alt="powerfull-feature-icon" className="powerfull-feature-icon" />
                            <h1 className="powerfull-feature-card-title">Inventory Management</h1>
                            <p className="powerfull-feature-card-description">Take control of your supply chain with intelligent inventory tracking. Automated reorder alerts, waste tracking, and detailed
                                cost analysis help you optimize food costs and reduce waste significantly
                            </p>
                            <img src={PowerfullFeatureImage4} className="powerfull-feature-image second-image" alt="powerfull-feature-image" />
                        </div>
                    </div>

                    <div className="powerfull-feature-card">
                        <div className="powerfull-feature-card-content-container">
                            <img src={PowerfullFeatureIcon5} alt="powerfull-feature-icon" className="powerfull-feature-icon" />
                            <h1 className="powerfull-feature-card-title">Reporting & Analytics</h1>
                            <p className="powerfull-feature-card-description">Make data-driven decisions with comprehensive analytics dashboard. Track sales performance, customer behavior, peak
                                hours, and profitability metrics with beautiful, actionable insights and reports.
                            </p>
                            <img src={PowerfullFeatureImage7} className="powerfull-feature-image" alt="powerfull-feature-image" />
                        </div>
                    </div>

                    <div className="powerfull-feature-card">
                        <div className="powerfull-feature-card-content-container">
                            <img src={PowerfullFeatureIcon6} alt="powerfull-feature-icon" className="powerfull-feature-icon" />
                            <h1 className="powerfull-feature-card-title">Franchise Management</h1>
                            <p className="powerfull-feature-card-description">Scale your restaurant empire with centralized franchise management. Monitor multiple locations, standardize operations,
                                track performance across all outlets, and maintain brand consistency effortlessly.
                            </p>
                            <img src={PowerfullFeatureImage8} className="powerfull-feature-image second-image" alt="powerfull-feature-image" />
                        </div>
                    </div>

                    <div className="powerfull-feature-food-cards-container">
                        <div className="powerfull-feature-food-card">
                            <img src={PowerfullFeatureImage5} alt="powerfull-feature-image" className="powerfull-feature-image-food" />
                            <div className="powerfull-feature-food-content">
                                <h1 className="powerfull-feature-food-title">Contactless Dining</h1>
                                <p className="powerfull-feature-food-description">Offer safe, convenient dining experiences with QR code-based digital menus. Enable contactless ordering, payment processing, and feedback collection while maintaining the personal touch your customers love.</p>
                            </div>
                        </div>

                        <div className="powerfull-feature-food-card">
                            <div className="powerfull-feature-food-content">
                                <h1 className="powerfull-feature-food-title">Captain/Waiter App</h1>
                                <p className="powerfull-feature-food-description">Empower your staff with our intuitive mobile app for seamless order processing. Take orders tableside, split bills, apply discounts, and send orders directly to the kitchen with just a few taps.</p>
                            </div>
                            <img src={PowerfullFeatureImage6} alt="powerfull-feature-image" className="powerfull-feature-image-food" />
                        </div>
                    </div>

                </div>
            </div>

            <div className="why-choose-platform-main-container">
                <div className="why-choose-content-container">
                    <h1 className="why-choose-heading">Why Choose Our Platform?</h1>
                    <p className="why-choose-description">Discover how our billing software transforms your business operations across every touchpoint</p>
                </div>

                <div className="slider-wrapper">
                    <Slider {...settings}>
                        <div className="slide">
                            <div className="slide-content">
                                <div className="image-section">
                                    <img
                                        src={SliderImage1}
                                        alt="Analytics Screenshot"

                                    />
                                </div>
                                <div className="text-section">
                                    <span className="badge">👑 For Owners</span>
                                    <h2>Scale Your Business with Smart Insights</h2>
                                    <p>Take control of your business growth with powerful analytics and automated processes that drive results.</p>
                                    <ul className="features">
                                        <li>

                                            <img src={SlickIconImage1} alt="Slick-icon-image" className="icon" />
                                            <div>
                                                <strong>Real-time Revenue Tracking</strong><br />
                                                Monitor sales performance and identify growth opportunities instantly.
                                            </div>
                                        </li>
                                        <li>

                                            <img src={SlickIconImage2} alt="Slick-icon-image" className="icon" />
                                            <div>
                                                <strong>Automated Growth Reports</strong><br />
                                                Get detailed insights on customer behavior and business trends.
                                            </div>
                                        </li>
                                        <li>

                                            <img src={SlickIconImage3} alt="Slick-icon-image" className="icon" />
                                            <div>
                                                <strong>Profit Optimization</strong><br />
                                                Maximize margins with intelligent pricing and cost analysis.
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="slide">
                            <div className="slide-content">
                                <div className="image-section">
                                    <img
                                        src={SliderImage2}
                                        alt="Analytics Screenshot"
                                    />
                                </div>
                                <div className="text-section">
                                    <span className="badge">🍽️ For Customers</span>
                                    <h2>Make Dining Effortless for Your Customers</h2>
                                    <p>Deliver a seamless dining experience with digital menus, instant orders, and flexible payments.</p>
                                    <ul className="features">
                                        <li>

                                            <img src={SlickIconImage4} alt="Slick-icon-image" className="icon" />
                                            <div>
                                                <strong> Digital Menu Access</strong><br />
                                                Customers can browse and order directly from their devices.
                                            </div>
                                        </li>
                                        <li>

                                            <img src={SlickIconImage5} alt="Slick-icon-image" className="icon" />
                                            <div>
                                                <strong> No Waiting Time</strong><br />
                                                Faster ordering means happier, repeat customers.
                                            </div>
                                        </li>
                                        <li>

                                            <img src={SlickIconImage6} alt="Slick-icon-image" className="icon" />
                                            <div>
                                                <strong>Smart Payments</strong><br />
                                                Pay via UPI, card, or cash — hassle free.
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="slide">
                            <div className="slide-content">
                                <div className="image-section">
                                    <img
                                        src={SliderImage3}
                                        alt="Analytics Screenshot"
                                    />
                                </div>
                                <div className="text-section">
                                    <span className="badge">🏢 For Franchise</span>
                                    <h2>One Dashboard for All Your Outlets</h2>
                                    <p>Stay in control with a consolidated view of your entire business and branch performance.</p>
                                    <ul className="features">
                                        <li>

                                            <img src={SlickIconImage7} alt="Slick-icon-image" className="icon" />
                                            <div>
                                                <strong>Multi-Outlet Management</strong><br />
                                                Monitor and manage all locations from one place.
                                            </div>
                                        </li>
                                        <li>

                                            <img src={SlickIconImage8} alt="Slick-icon-image" className="icon" />
                                            <div>
                                                <strong>Detailed Reporting</strong><br />
                                                Get insights on performance across every outlet.
                                            </div>
                                        </li>
                                        <li>

                                            <img src={SlickIconImage9} alt="Slick-icon-image" className="icon" />
                                            <div>
                                                <strong>Centralized Control</strong><br />
                                                Sync menus, pricing, and offers across branches easily.
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>

            </div>

            <div className="never-miss-main-container">
                <div className="never-miss-card-container">
                    <div className="never-miss-content">
                        <h1 className="never-miss-main-heading">NEVER MISS A BEAT <span className="never-span">OR A SALE.</span></h1>
                        <p className="never-miss-description">Our powerful offline mode keeps your business running, even when your internet isn't.</p>
                        <div className="never-miss-buttons-container">
                            <button className="never-miss-button" onClick={scrollToSection}>Start Free Trial</button>
                            <button className="never-miss-button never-demo-button" onClick={scrollToSection}>Watch Demo</button>
                        </div>
                    </div>
                    <div>
                        <img src={NeverMissImage} alt="Never-miss-image" className="never-miss-image" />
                    </div>
                </div>
            </div>

            <div className="various-establlishment-main-container-hotel">
                <h1 className="various-establishment-heading-hotel">
                    Versatile Across Various Establishments
                </h1>

                <div className="various-establishment-buttons-container-hotel">
                    {hotelData.map((est, index) => (
                        <button
                            key={index}
                            className={`various-establishment-button-hotel ${selected.name === est.name ? "active" : ""
                                }`}
                            onClick={() => setSelected(est)}
                        >
                            {est.name}
                        </button>
                    ))}
                </div>

                <div className="various-establishment-content-container-hotel">
                    <div className="various-establishment-content-hotel">
                        <h1 className="varous-establishment-title-hotel">{selected.title}</h1>
                        <ul>
                            {selected.points.map((point, index) => (
                                <li key={index} className="various-points-hotel">
                                    {point}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <img
                        src={selected.image}
                        alt={`${selected.name.toLowerCase()}-image`}
                        className="super-market-image-hotel mobile-super-market-image-hotel"
                    />
                </div>
            </div>

            <div className="choose-plan-top-main-container" ref={sectionRefPlan}>
                <div className="choose-plan-main-container">
                    <div className="choose-plan-heading-section">
                        <h1 className="choose-plan-heading">Choose Your Plan</h1>
                        <p className="choose-plan-description">Streamline your restaurant operations with our comprehensive management solutions</p>
                    </div>
                    <div className="choose-plans-cards-container">

                        <div className="choose-plan-card">
                            <h1 className="plan-title">Standard Plan</h1>
                            <p className="plan-description">Perfect for growing restaurants</p>
                            <h1 className="plan-cost">₹8,500 <span className="price-sub-text">/year/Outlet (incl. GST)</span></h1>
                            <div className="plan-points-container">
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Table Order Management</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Contactless Dining</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Inventory Management</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Kitchen Display System</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Reports & Analytics</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Franchise</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">24/7 Support</p>
                                </div>
                                 <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">QR Code Menu Ordering</p>
                                </div>
                                 <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Captain/Waiter App</p>
                                </div>
                                 <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Merchant Apps</p>
                                </div>
                            </div>
                            <div className="plan-addons-container">
                                <h1 className="plan-addon-heading">Available Add-ons</h1>
                                <div className="whatsapp-plan-container">
                                    <div className="whatsapp-heading">
                                        <img src={WhatsappSmallIcon} alt="whatsapp-icon" className="whatsapp-small-icon" />
                                        <p className="whatsapp-title">whatsapp <span className="plans-all-text">Available with both plans</span></p>
                                    </div>
                                    <p className="plans-fotter-message">₹ 0.15 paisa/per message  (Excluding GST)</p>
                                </div>
                                <div className="plan-button-container">
                                    <button className="plan-buttons">Get Started</button>
                                </div>
                            </div>


                        </div>

                        <div className="choose-plan-card Premium-Plan">
                            <div className="most-popular-button-container">
                                <button className="most-popular">Most Popular</button>
                            </div>
                            <h1 className="plan-title">Premium Plan</h1>
                            <p className="plan-description premium-description">Complete restaurant solution</p>
                            <h1 className="plan-cost">₹10,000 <span className="price-sub-text-premium">/year/Outlet (incl. GST)</span></h1>
                            <div className="plan-points-container">
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text-bold">Swiggy Integration</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text-bold">Zomato Integration</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Table Order Management</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Contactless Dining</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Inventory Management</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Kitchen Display System</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Reports & Analytics</p>
                                </div>

                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Franchise</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">24/7 Support</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">QR Code Menu Ordering</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Captain/Waiter App</p>
                                </div>
                                 <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Merchant App</p>
                                </div>
                            </div>
                            <div className="plan-addons-container">
                                <h1 className="plan-addon-heading">Available Add-ons</h1>
                                <div className="whatsapp-plan-container Premium-Plan-whatsapp">
                                    <div className="whatsapp-heading">
                                        <img src={WhatsappSmallIcon} alt="whatsapp-icon" className="whatsapp-small-icon" />
                                        <p className="whatsapp-title">whatsapp <span className="plans-all-text">Available with both plans</span></p>
                                    </div>
                                    <p className="plans-fotter-message">₹ 0.15 paisa/per message  (Excluding GST)</p>
                                </div>
                                <div className="plan-button-container">
                                    <button className="plan-buttons premium-button">Get Started</button>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

            <div className="contact-form-main-container-about" ref={sectionRef}>
                <div className="contact-form-content-container">
                    <div className="contactus-buttons-container">
                        <button
                            className={`contactus-form-buttons ${activeView === 'contact' ? 'active' : ''}`}
                            onClick={() => setActiveView('contact')}
                        >
                            <img src={MessageIcon} alt="message-icon" className="contact-form-icons" />
                            Contact Form
                        </button>

                        <button
                            className={`contactus-form-buttons ${activeView === 'location' ? 'active' : ''}`}
                            onClick={() => setActiveView('location')}
                        >
                            <img src={LocationIcon} alt="location-icon" className="contact-form-icons" />
                            Location
                        </button>
                    </div>



                    {activeView === 'contact' ? (
                        <>
                            <img src={sendMessageImage} alt="send-message-icon" className="send-message-icon" />
                            <h1 className="send-message-heading">Book a Demo</h1>
                            <p className="send-message-description">
                                Fill out the form below and connect us instantly.
                            </p>

                            <form className="send-message-form-main" onSubmit={handleWhatsAppSubmit}>
                                <div className="send-message-form">
                                    <div className="input-container">
                                        <label>Full Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="John Doe"
                                            className="input-field"
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    {/* <div className="input-container">
                                        <label>Email Address</label>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="john@example.com"
                                            className="input-field"
                                            onChange={handleChange}
                                            required
                                        />
                                    </div> */}
                                </div>

                                <div className="input-container">
                                    <label>Product</label>
                                    <select
                                        name="product"
                                        className="input-field"
                                        onChange={handleChange}
                                        required
                                    >
                                        {/* <option value="">Select a product</option> */}
                                        <option value="Fleet Eats">Fleet Eats</option>
                                        {/* <option value="Fleet Mart">Fleet Mart</option>
                                        <option value="Fleet Stay">Fleet Stay</option>
                                        <option value="Fleet Office">Fleet Office</option> */}
                                    </select>
                                </div>

                                {/* <div className="input-container">
                                    <label>Message</label>
                                    <textarea
                                        name="message"
                                        placeholder="Type your message here..."
                                        className="input-field"
                                        rows="6"
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div> */}

                                <button type="submit" className="send-message-button">
                                    Connect Us
                                </button>
                            </form>
                        </>
                    ) : (
                        // Location View
                        <div className="map-image-background">
                            <div className="reach-out-cards-container">
                               
                              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.5253765500493!2d78.37664357522262!3d17.434550583460727!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93e37831f177%3A0x32d4499d34baaa78!2sT-Hub%20Phase%202!5e0!3m2!1sen!2sin!4v1781782551831!5m2!1sen!2sin" 
                                width="600" 
                                height="450" 
                                style={{ border: 0 }} 
                                allowfullscreen 
                                loading="lazy" 
                                referrerpolicy="no-referrer-when-downgrade"
                                title="Thub Phase 2 Map"
                                ></iframe>
                            </div>
                        </div>

                    )}

                </div>
            </div>
            <Footer />
        </>
    )
}

export default Food